var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChecklistEndApproveAllSensia = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 37,
  viewBox: "0 0 38 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.9997 3.0835C10.4897 3.0835 3.58301 9.99016 3.58301 18.5002C3.58301 27.0102 10.4897 33.9168 18.9997 33.9168C27.5097 33.9168 34.4163 27.0102 34.4163 18.5002C34.4163 9.99016 27.5097 3.0835 18.9997 3.0835ZM18.9997 30.8335C12.2009 30.8335 6.66634 25.2989 6.66634 18.5002C6.66634 11.7014 12.2009 6.16683 18.9997 6.16683C25.7984 6.16683 31.333 11.7014 31.333 18.5002C31.333 25.2989 25.7984 30.8335 18.9997 30.8335ZM24.9813 12.7806L15.9163 21.8456L13.018 18.9472C12.73 18.6586 12.3389 18.4963 11.9311 18.4963C11.5233 18.4963 11.1323 18.6586 10.8443 18.9472C10.243 19.5485 10.243 20.5197 10.8443 21.121L14.8372 25.1139C15.4384 25.7152 16.4097 25.7152 17.0109 25.1139L27.1705 14.9543C27.7718 14.3531 27.7718 13.3818 27.1705 12.7806C26.5693 12.1793 25.5826 12.1793 24.9813 12.7806Z",
  fill: "#86AA63"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChecklistEndApproveAllSensia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checklist-end-approve-all-sensia.4f3fc2c4fffaa626dbcf7c69f417e9b1.svg";